<template>
  <section v-if="shouldShownLastSearches" class="search-history">
    <div class="grid-x align-middle align-justify margin-bottom-s large-margin-bottom-s">
      <h6>Recent searches</h6>
      <button type="button" @click="clearHistoryAndFocus">
        <span class="link-med">Clear All</span>
      </button>
    </div>

    <ul ref="listEl" class="grid-y">
      <li v-for="(item, index) in visibleSearchHistory" :key="item" role="option" @click="emits('select', { item: item, index: index })">
        <Link
          class="undecorated-link text-left"
          :href="buildSearchUrl(item)"
          @keydown.arrow-up.prevent="onKeydownArrowUp"
          @keydown.arrow-down.prevent="onKeydownArrowDown"
        >
          {{ item }}
        </Link>
      </li>
    </ul>
  </section>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, ref } from 'vue';
import useSearchHistory from '~/composables/dumb/useSearchHistory';
import Link from '../common/Link';
import { useSearchResultList } from '~/composables/accessibility/useSearchResultList';
import { GET_IS_MOBILE_VIEW } from '#shared/types/getters';
import useSearchUrl from '~/composables/ui/useSearchUrl';

const emits = defineEmits(['select', 'cleared']);

const navViewType = useNavViewType();
const { buildSearchUrl } = useSearchUrl();

const listEl = ref(null);

const { onKeydownArrowUp, onKeydownArrowDown } = useSearchResultList({ listEl });

const MAX_HISTORY_ITEMS_MOBILE = 3;
const MAX_HISTORY_ITEMS_DESKTOP = 5;

const { searchHistory, clearSearchHistory } = useSearchHistory();
const shouldShownLastSearches = computed(() => Boolean(searchHistory.value.length));
const isMobile = computed(() => navViewType[GET_IS_MOBILE_VIEW]);
const visibleSearchHistory = computed(() => {
  return searchHistory.value.slice(0, isMobile.value ? MAX_HISTORY_ITEMS_MOBILE : MAX_HISTORY_ITEMS_DESKTOP);
});

function clearHistoryAndFocus() {
  clearSearchHistory();
  emits('cleared');
}

defineExpose({ listEl });
</script>

<style lang="scss" scoped>
@import '~/assets/scss/mixins/index.scss';

button {
  color: $gray-1-color;
  align-self: flex-start;
}

a {
  color: $gray-1-color;
  display: block;
  &:hover,
  &:focus {
    color: $highlight-color;
  }
}
</style>

<style lang="scss" scoped brand="mcom">
@import '~/assets/scss/mixins.mcom.scss';

ul {
  gap: 16px;
  @include breakpoint(medium down) {
    gap: 20px;
  }
}
</style>

<style lang="scss" scoped brand="bcom">
@import '~/assets/scss/mixins.bcom.scss';

ul {
  gap: 16px;
  @include breakpoint(medium down) {
    gap: 22px;
  }
}
</style>
